/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Input from '../../../adminv2/common/Input'
import CheckboxRadio from '../../../adminv2/common/CheckboxRadio'
import Select, { components } from 'react-select'
import Consultations from '@services/Consultations'
import CompanyModal from './Company.Modal'
import Alert from '../../../adminv2/common/Alert'
import { history } from '@services/History'
import { showAlert } from '../alert/Alert.dux'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc'
import { FEATURE_FLAGS } from '@feature-flags/feature-flags.constants'
import { FEATURES } from '@feature-flags/features.constants'
import Customer from '@services/Customer'

import './Company.Form.scss'

async function runSequential(tasks) {
  const results = []
  for (const task of tasks) {
    results.push(await task())
  }
  return results
}

export default function CompanyFormNew2(props) {
  let company = props.company
  let { formData, setFormData, initialFormData, setInitialFormData } = props
  const companyClient = Consultations.company
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const companyConfigurationsClient = Customer.companyConfigurations
  const [showModal, setShowModal] = useState(false)
  const [name, setName] = useState(company ? company.name : '')
  const [specialities, setSpecialities] = useState(props.specialities)
  const [selectedSpeciality, setSelectedSpeciality] = useState()
  const [selectedPreferedSpecialities, setSelectedPreferedSpecialities] = useState()
  const [selectedSector, setSelectedSector] = useState()
  const [sectors, setSectors] = useState()
  const [regions] = useState([
    {
      value: 'mexico',
      label: 'México',
    },
    {
      value: 'barcelona',
      label: 'Barcelona',
    },
    {
      value: 'middle east',
      label: 'Middle East',
    },
  ])
  const [selectedRegion, setSelectedRegion] = useState()
  const [selectedArea, setSelectedArea] = useState()
  const [areas, setAreas] = useState()
  const [statusOptions, setStatusOptions] = useState([
    { label: t('active'), checked: company ? company?.active : true, name: 'status_true', value: 'on' },
    { label: t('baja'), checked: company ? !company?.active : false, name: 'status_false', value: 'off' },
  ])
  const [potentialOptions, setPotentialOptions] = useState([
    { label: 'A', checked: company?.potential === 'a', name: 'a' },
    { label: 'B', checked: company?.potential === 'b', name: 'b' },
    { label: 'C', checked: company?.potential === 'c', name: 'c' },
  ])

  const [homepageOptions, setHomepageOptions] = useState([
    {
      label: 'Lista profesionales',
      checked: company?.homepage === 'professionalList' || company?.homepage === null,
      name: 'professionalList',
    },
    { label: 'Feed', checked: company?.homepage === 'feeds', name: 'feeds' },
  ])

  const [objectiveOptions, setObjectiveOptions] = useState([
    { label: t('Empleados'), checked: company && company?.objective === 'Empleados', name: 'Empleados' },
    {
      label: t('Siniestralidad'),
      checked: !company || !company.objective || company.objective === 'Siniestralidad' ? true : false,
      name: 'Siniestralidad',
    },
    {
      label: t('Venta de producto'),
      checked: company && company?.objective === 'Venta de producto',
      name: 'Venta de producto',
    },
  ])
  const [meetingTypeOptions, setMeetingTypeOptions] = useState([
    { label: 'MeetingDoctors', checked: company?.meeting_type === 'md', name: 'md' },
    { label: 'MeetingVets', checked: company?.meeting_type === 'mv', name: 'mv' },
    { label: 'MeetingPros', checked: company?.meeting_type === 'mp', name: 'mp' },
  ])
  const [hasVideoCallOptions, setHasVideoCallOptions] = useState([
    { label: t('Si'), checked: company ? company.has_video_call : false, name: 1, value: 'on' },
    { label: t('No'), checked: company ? !company.has_video_call : true, name: 0, value: 'off' },
  ])
  const [hasFeedOptions, setHasFeedOptions] = useState([
    { label: t('Si'), checked: company ? company.has_feed : false, name: 1, value: 'on' },
    { label: t('No'), checked: company ? !company.has_feed : true, name: 0, value: 'off' },
  ])
  const [hasVideoCall1to1Options, setHasVideoCall1to1Options] = useState([
    { label: t('Si'), checked: company?.has_video_call_1to1 === 1, name: 1, value: 'on' },
    { label: t('No'), checked: company ? company.has_video_call_1to1 === 0 : true, name: 0, value: 'off' },
  ])
  const [hasMedicalReportsOptions, setHasMedicalReportsOptions] = useState([
    { label: t('Si'), checked: company?.has_medical_reports === 1, name: 1, value: 'on' },
    { label: t('No'), checked: company ? company.has_medical_reports === 0 : true, name: 0, value: 'off' },
  ])
  const [hasMedicalDerivationsOptions, setHasMedicalDerivationsOptions] = useState([
    { label: t('Si'), checked: company?.has_medical_derivations === 1, name: 1, value: 'on' },
    { label: t('No'), checked: company ? company.has_medical_derivations === 0 : true, name: 0, value: 'off' },
  ])
  const [hasPrescriptionOptions, setHasPrescriptionOptions] = useState([
    { label: t('Si'), checked: company?.has_prescription === 1, name: 1, value: 'on' },
    { label: t('No'), checked: company ? company.has_prescription === 0 : true, name: 0, value: 'off' },
  ])
  const [hasDataReportOptions, setHasDataReportOptions] = useState([
    { label: t('Si'), checked: company?.data_report === 1, name: 1, value: 'on' },
    { label: t('No'), checked: company ? company.data_report === 0 : true, name: 0, value: 'off' },
  ])
  const [termsAcceptedByDefaultOptions, setTermsAcceptedByDefaultOptions] = useState([
    { label: t('Si'), checked: !!company?.configurations?.terms_accepted_by_default, name: 1, value: 'on' },
    { label: t('No'), checked: !company?.configurations?.terms_accepted_by_default, name: 0, value: 'off' },
  ])

  // * Select Getters / Setters
  useEffect(() => {
    getAndSetSpecialitiesOptions()
    getAndSetAreasOptions()
    getAndSetSectorOptions()
    initializeFormData()
    return () => {
      setSpecialities()
      setSelectedSpeciality()
      setAreas()
      setSelectedArea()
      setSectors()
      setSelectedSector()
      setSelectedRegion()
    }
  }, [])

  useEffect(() => {
    if (selectedPreferedSpecialities?.length > 0) {
      let newArray = selectedPreferedSpecialities
      selectedPreferedSpecialities.forEach((selected, index) => {
        if (!selectedSpeciality.some((e) => e.value === selected.value)) {
          newArray.splice(index, 1)
        }
      })

      setSelectedPreferedSpecialities(newArray)
      setFormData({ ...formData, selectedPreferedSpecialities: newArray.map((e) => e.value) })
    }
  }, [selectedSpeciality])

  const formatSpecialities = (data) => {
    let result = data
    const orderSpecialitiesByName = data.sort((a, b) => (b.name < a.name ? 1 : -1))
    result = orderSpecialitiesByName.map((element) => ({
      value: element.id,
      label: element.name,
      code: element.code,
    }))

    return result
  }

  const comparePositions = (a, b) => {
    var positionA = a.pivot?.position
    var positionB = b.pivot?.position

    if (positionA < positionB) {
      return -1
    }
    if (positionA > positionB) {
      return 1
    }

    return 0
  }

  const getAndSetSpecialitiesOptions = () => {
    let selectFormatted = []
    selectFormatted = formatSpecialities(specialities)

    setSpecialities(selectFormatted)

    let preferedSpecialitiesFormatted = []
    let selectedSpecialitiesFiltered = []

    if (company && company.specialities && company.specialities.length > 0) {
      preferedSpecialitiesFormatted = company.specialities
        .filter((speciality) => speciality.pivot?.position)
        .sort(comparePositions)
        .map((element) => ({ value: element.id, label: element.name, code: element.code }))

      selectedSpecialitiesFiltered = company.specialities.map((element) => ({
        value: element.id,
        label: element.name,
        code: element.code,
      }))
    }

    setSelectedSpeciality(selectedSpecialitiesFiltered)
    setSelectedPreferedSpecialities(preferedSpecialitiesFormatted)
  }
  const getAndSetAreasOptions = () => {
    Consultations.area
      .index()
      .then((response) => {
        let selectFormatted = []
        if (response && response.data) {
          selectFormatted = response.data.map((element) => ({
            value: element.id,
            label: element.name,
          }))
        }
        setAreas(selectFormatted)
        return selectFormatted
      })
      .then((areasFormatted) => {
        let newArray = []
        if (company && company.areas && company.areas.length > 0) {
          let companyAreasIds = company.areas.map((element) => element.id)
          newArray = areasFormatted.filter((item) => companyAreasIds.includes(item.value))
        }
        setSelectedArea(newArray)
      })
  }
  const getAndSetSectorOptions = () => {
    Consultations.sectors
      .index()
      .then((response) => {
        let selectFormatted = []
        if (response && response.data) {
          selectFormatted = response.data.map((element) => ({
            value: element.id,
            label: element.name,
          }))
        }
        setSectors(selectFormatted)
        return selectFormatted
      })
      .then((sectorsFormatted) => {
        let companySector
        if (company && company.sector_id) {
          companySector = sectorsFormatted.find((element) => element.value === company.sector_id)
        }
        setSelectedSector(companySector)
      })
  }
  const initializeFormData = () => {
    let formattedPreferedSpecialities = company?.specialities
      ? company.specialities
          .filter((speciality) => speciality.pivot?.position)
          .sort(comparePositions)
          .map((e) => e.id)
      : []

    let formatedSpecialities = company?.specialities ? company.specialities.map((e) => e.id) : []
    let initial = {
      status: company?.active ? company.active : '',
      name: company?.name ? company?.name : '',
      fiscal_name: company?.fiscal_name ? company.fiscal_name : '',
      support_email: company?.support_email ? company.support_email : '',
      sms_sender_name: company?.sms_sender_name ? company.sms_sender_name : '',
      potential: company?.potential ? company.potential : '',
      objective: company?.objective ? company.objective : '',
      meeting_type: company?.meeting_type ? company.meeting_type : '',
      has_video_call: company?.has_video_call ? (company.has_video_call === 1 ? 'on' : 'off') : '',
      has_video_call_1to1: company?.has_video_call_1to1 ? (company.has_video_call_1to1 === 1 ? 'on' : 'off') : '',
      has_medical_reports: company?.has_medical_reports ? (company.has_medical_reports === 1 ? 'on' : 'off') : '',
      has_medical_derivations: company?.has_medical_derivations
        ? company.has_medical_derivations === 1
          ? 'on'
          : 'off'
        : '',
      has_prescription: company?.has_prescription ? (company.has_prescription === 1 ? 'on' : 'off') : '',
      has_data_report: company?.data_report ? (company.data_report === 1 ? 'on' : 'off') : '',
      key_account: company?.key_account ? company.key_account : '',
      protocol: company?.protocol ? company.protocol : '',
      terms_accepted_by_default: !!company?.configurations?.terms_accepted_by_default ? 'on' : 'off',

      //Selects
      sector_id: company?.sector_id ? company.sector_id : '',
      region: company?.region ? company.region : '',
      areas: company?.areas ? company.areas : [],
      selectedPreferedSpecialities: formattedPreferedSpecialities,
      specialities: formatedSpecialities.filter((element) => !formattedPreferedSpecialities.includes(element)),
    }
    setSelectedRegion(regions.find((el) => (el.value === company?.region ? company?.region : null)))

    setInitialFormData(initial)
    setFormData(initial)
  }

  const successAlertOpening = () => {
    dispatch(
      showAlert({
        text: t('generalUpdateSuccessMessage'),
        important: t('goodJob'),
        type: 'success',
      })
    )
  }
  const failureAlertOpening = () => {
    dispatch(
      showAlert({
        text: t('generalUpdatingErrorMEssage'),
        important: 'Oh snap!',
        type: 'danger',
      })
    )
  }

  // * Form Submit logic
  const handleSubmit = async (e) => {
    e.preventDefault()
    const form = document.getElementById('company-form')
    const formDataLocal = new FormData(form)
    const formProps = Object.fromEntries(formDataLocal)
    let formattedValues = formatData(formProps)

    if (company && company.id) {
      Promise.all([
        companyClient.update(company.id, formattedValues),
        companyConfigurationsClient.partialUpdate(company.id, {
          data: {
            terms_accepted_by_default: formattedValues.terms_accepted_by_default,
          },
        }),
      ])
        .then((res) => successAlertOpening())
        .then((res) => setInitialFormData(formData))
        .catch((err) => {
          failureAlertOpening()
        })
    } else {
      companyClient
        .store(formattedValues)
        .then((res) => {
          return companyConfigurationsClient.partialUpdate(res.data.id, {
            data: {
              terms_accepted_by_default: formattedValues.terms_accepted_by_default,
            },
          })
        })
        .then((res) => successAlertOpening())
        .then(() => {
          dispatch(
            showAlert({
              text: `${t('generalCreateCompanySuccessMessage')} ${formattedValues.name}`,
              important: '',
              type: 'success',
            })
          )
          history.push('/companies')
        })
        .then((res) => setInitialFormData(formData))
        .catch((err) => {
          failureAlertOpening()
        })
    }
  }

  const formatSpecialitiesMatrix = (array1, array2) => {
    let array1ids = array1?.map((el) => el.value)
    let array2ids = (array2 = array2?.map((el) => el.value))

    let resultArray = []
    array1ids?.map((el, index) => resultArray.push({ id: el, position: index + 1 }))
    array2ids?.map((el) => (!array1ids.includes(el) ? resultArray.push({ id: el, position: null }) : null))

    return resultArray
  }

  const formatData = (params) => {
    let specialitiesArrayWithoutAll = selectedSpeciality.filter((element) => element.value !== 'all')
    // let specialitiesFormatted = specialitiesArrayWithoutAll.map((element) => element.value)

    let specialitiesCombined = formatSpecialitiesMatrix(selectedPreferedSpecialities, specialitiesArrayWithoutAll)

    let result = {
      name: params.name,
      fiscal_name: params.fiscal_name,
      support_email: params.support_email,
      sms_sender_name: params.sms_sender_name ? params.sms_sender_name : params.name,
      sector_id: selectedSector.value,
      region: selectedRegion.value,

      // speciality_ids: specialitiesMatrix ? specialitiesMatrix : [],
      area_ids: selectedArea ? selectedArea.map((element) => element.value) : [],
      objective: params.objective,
      potential: params.potential,
      meeting_type: params.meeting_type,
      active: params.status === 'on' ? 1 : 0,
      has_medical_derivations: params.has_medical_derivations === 'on' ? 1 : 0,
      has_medical_reports: params.has_medical_reports === 'on' ? 1 : 0,
      has_prescription: params.has_prescription === 'on' ? 1 : 0,
      has_video_call: params.has_video_call === 'on' ? 1 : 0,
      has_video_call_1to1: params.has_video_call_1to1 === 'on' ? 1 : 0,
      has_feed: params.has_feed === 'on' ? 1 : 0,
      homepage: params.homepage,
      data_report: params.has_data_report === 'on' ? 1 : 0,
      speciality_ids: specialitiesCombined,
      key_account: params.key_account,
      protocol: company?.protocol ? company.protocol : '',
      terms_accepted_by_default: params.terms_accepted_by_default === 'on',
    }

    /**
     * *Añadimos Medicina Gedneral en caso de que no esté seleccionado
     */
    let hasGeneralMedicine = specialitiesCombined.find((element) => element.id === 1)
    if (hasGeneralMedicine === undefined && result.has_video_call === 1) {
      specialitiesCombined.push({
        id: 1,
        position: null,
      })
    }

    return result
  }

  const checkUnsavedChanges = () => {
    let isDirty = _.isEqual(formData, initialFormData)
    return isDirty
  }

  const SortableSelect = SortableContainer(Select)
  function arrayMove(array, from, to) {
    array = array.slice()
    array.splice(to < 0 ? array.length + to : to, 0, array.splice(from, 1)[0])
    return array
  }

  const onSortEnd = ({ oldIndex, newIndex }) => {
    const newValue = arrayMove(selectedPreferedSpecialities, oldIndex, newIndex)
    setSelectedPreferedSpecialities(newValue)
    setFormData({ ...formData, selectedPreferedSpecialities: newValue.map((e) => e.value) })
  }

  const SortableMultiValue = SortableElement((props) => {
    const onMouseDown = (e) => {
      e.preventDefault()
      e.stopPropagation()
    }
    const innerProps = { ...props.innerProps, onMouseDown }
    return <components.MultiValue {...props} innerProps={innerProps} />
  })

  const SortableMultiValueLabel = SortableHandle((props) => <components.MultiValueLabel {...props} />)

  return (
    <div className="companies-form md-form ">
      {showModal ? (
        <CompanyModal
          close={() => setShowModal(false)}
          onCancel={() => setShowModal(false)}
          onSave={(e) => {
            document.getElementById('company-submit-btn').click()
            setShowModal(false)
          }}
          onReset={() => history.push('/companies')}
        />
      ) : null}
      <Alert timeOut={3000} />
      <form className="integration-form" onSubmit={handleSubmit} id="company-form">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h1>{t('Datos compañía')}</h1>
          <CheckboxRadio
            className="form-control"
            id="status"
            name="status"
            label={`Status`}
            options={statusOptions}
            handleOptions={(options) => {
              setStatusOptions(options)
              setFormData({ ...formData, status: options.find((e) => e.checked).value })
            }}
            type="radio"
            required
          />
        </div>
        <Input
          className="form-control"
          id="name"
          name="name"
          label={`${t('Nombre')}`}
          defaultValue={company?.name || ''}
          required
          onChange={(name) => {
            setName(name)
            setFormData({ ...formData, name: name })
          }}
        />
        <Input
          className="form-control"
          id="fiscal_name"
          name="fiscal_name"
          label={`${t('fiscal_name')}`}
          defaultValue={company?.fiscal_name || ''}
          onChange={(fiscal_name) => setFormData({ ...formData, fiscal_name: fiscal_name })}
          required
        />
        <Input
          className="form-control"
          id="support_email"
          name="support_email"
          label={`${t('mail_from_name')}`}
          defaultValue={company?.support_email || ''}
          onChange={(support_email) => setFormData({ ...formData, support_email: support_email })}
          type="email"
        />
        <Input
          className="form-control"
          id="sms_sender_name"
          name="sms_sender_name"
          label={`${t('sms_sender_name')}`}
          customvalue={company && company.sms_sender_name ? company.sms_sender_name : name}
          onChange={(sms_sender_name) => setFormData({ ...formData, sms_sender_name: sms_sender_name })}
          maxLength="11"
        />
        <CheckboxRadio
          className="form-control"
          id="potential"
          name="potential"
          label={t('Potencial')}
          options={potentialOptions}
          handleOptions={(options) => {
            setPotentialOptions(options)
            setFormData({ ...formData, potential: options.find((e) => e.checked).name })
          }}
          type="radio"
          required
        />
        {sectors ? (
          <div>
            <label>{`${t('Sector')} *:`}</label>
            <Select
              required
              name="sectors"
              options={sectors}
              value={selectedSector}
              onChange={(option) => {
                setSelectedSector(option)
                setFormData({ ...formData, sector_id: option.value })
              }}
            />
          </div>
        ) : null}
        <CheckboxRadio
          className="form-control"
          id="objective"
          name="objective"
          label={`${t('Objective')} / ${t('Use')}`}
          options={objectiveOptions}
          handleOptions={(options) => {
            setObjectiveOptions(options)
            setFormData({ ...formData, objective: options.find((e) => e.checked).name })
          }}
          type="radio"
          required
        />
        <hr></hr>
        <h1>{t('services')}</h1>
        <CheckboxRadio
          className="form-control"
          id="meeting_type"
          name="meeting_type"
          label={t('meeting_type')}
          options={meetingTypeOptions}
          handleOptions={(options) => {
            setMeetingTypeOptions(options)
            setFormData({ ...formData, meeting_type: options.find((e) => e.checked).name })
          }}
          type="radio"
          required
        />
        {meetingTypeOptions[2].checked && areas && selectedArea ? (
          <div>
            <label>{`${t('meeting_areas')}*:`}</label>
            <Select
              required
              isMulti
              name="areas"
              options={areas}
              defaultValue={selectedArea}
              onChange={(options) => {
                setSelectedArea(options)
                setFormData({ ...formData, areas: options.map((e) => e.value) })
              }}
            />
          </div>
        ) : null}

        <div className="selectors-container">
          <CheckboxRadio
            className="form-control md-field radio-horizontal"
            id="has_video_call"
            name="has_video_call"
            label={t('video_call')}
            options={hasVideoCallOptions}
            handleOptions={(options) => {
              setHasVideoCallOptions(options)
              setFormData({ ...formData, has_video_call: options.find((e) => e.checked).value })
            }}
            type="radio"
            required
          />
          <CheckboxRadio
            className="form-control md-field radio-horizontal"
            id="has_video_call_1to1"
            name="has_video_call_1to1"
            label={t('video_call_1to1')}
            options={hasVideoCall1to1Options}
            handleOptions={(options) => {
              setHasVideoCall1to1Options(options)
              setFormData({ ...formData, has_video_call_1to1: options.find((e) => e.checked).value })
            }}
            type="radio"
            required
          />
          <CheckboxRadio
            className="form-control md-field radio-horizontal"
            id="has_medical_reports"
            name="has_medical_reports"
            label={t('Informes / Reportes')}
            options={hasMedicalReportsOptions}
            handleOptions={(options) => {
              setHasMedicalReportsOptions(options)
              setFormData({ ...formData, has_medical_reports: options.find((e) => e.checked).value })
            }}
            type="radio"
            required
          />
          <CheckboxRadio
            className="form-control md-field radio-horizontal"
            id="has_medical_derivations"
            name="has_medical_derivations"
            label={t('derivations')}
            options={hasMedicalDerivationsOptions}
            handleOptions={(options) => {
              setHasMedicalDerivationsOptions(options)
              setFormData({ ...formData, has_medical_derivations: options.find((e) => e.checked).value })
            }}
            type="radio"
            required
          />

          <CheckboxRadio
            className="form-control md-field radio-horizontal"
            id="has_prescription"
            name="has_prescription"
            label={t('prescription')}
            options={hasPrescriptionOptions}
            handleOptions={(options) => {
              setHasPrescriptionOptions(options)
              setFormData({ ...formData, has_prescription: options.find((e) => e.checked).value })
            }}
            type="radio"
            required
          />
          <CheckboxRadio
            className="form-control md-field radio-horizontal"
            id="has_data_report"
            name="has_data_report"
            label={t('dataReport')}
            options={hasDataReportOptions}
            handleOptions={(options) => {
              setHasDataReportOptions(options)
              setFormData({ ...formData, has_data_report: options.find((e) => e.checked).value })
            }}
            type="radio"
            required
          />
        </div>
        <div>
          <label>{`${t('region')} *:`}</label>
          <Select
            required
            name="regions"
            options={regions}
            value={selectedRegion}
            onChange={(option) => {
              setSelectedRegion(option)
              setFormData({ ...formData, region: option.value })
            }}
          />
        </div>

        <Input
          className="form-control"
          id="key_account"
          name="key_account"
          label={`${t('KAMemail')} `}
          defaultValue={company?.key_account || ''}
          onChange={(key_account) => setFormData({ ...formData, key_account: key_account })}
          type="email"
          required
        />

        <div>
          <label>{`${t('Especialidades')} *:`}</label>
          {specialities && selectedSpeciality ? (
            <Select
              required
              isMulti
              name="specialities"
              options={specialities}
              defaultValue={selectedSpeciality}
              onChange={(options) => {
                setSelectedSpeciality(options)
                setFormData({ ...formData, specialities: options.map((e) => e.value) })
              }}
            />
          ) : null}
        </div>
        {selectedSpeciality?.length > 0 ? (
          <div>
            <label>{`${t('preferedSpecialities')}:`}</label>
            {specialities && selectedPreferedSpecialities ? (
              <SortableSelect
                useDragHandle
                axis="xy"
                onSortEnd={onSortEnd}
                distance={4}
                getHelperDimensions={({ node }) => node.getBoundingClientRect()}
                value={selectedPreferedSpecialities}
                isMulti
                name="specialities"
                options={selectedSpeciality}
                defaultValue={selectedPreferedSpecialities}
                onChange={(options) => {
                  setSelectedPreferedSpecialities(options)
                  setFormData({ ...formData, selectedPreferedSpecialities: options.map((e) => e.value) })
                }}
                components={{
                  MultiValue: SortableMultiValue,
                  MultiValueLabel: SortableMultiValueLabel,
                }}
              />
            ) : null}
          </div>
        ) : null}
        <hr></hr>
        <h1>
          {t('termsAndConditions', {
            defaultValue: 'Términos y Condiciones',
          })}
        </h1>
        <CheckboxRadio
          className="form-control"
          id="terms_accepted_by_default"
          name="terms_accepted_by_default"
          label={t('termsAndConditionsAcceptedByDefault', {
            defaultValue: 'Términos y Condiciones Aceptados por defecto',
          })}
          options={termsAcceptedByDefaultOptions}
          handleOptions={(options) => {
            setTermsAcceptedByDefaultOptions(options)
            setFormData({ ...formData, terms_accepted_by_default: options.find((e) => e.checked).name })
          }}
          type="radio"
        />
        {FEATURE_FLAGS[FEATURES.CONTENT] ? (
          <>
            <hr></hr>
            <h1>{t('menuNeeds')}</h1>
            <div className="feed-section">
              <CheckboxRadio
                className="form-control md-field radio-horizontal"
                id="has_feed"
                name="has_feed"
                label="Feed:"
                options={hasFeedOptions}
                handleOptions={(options) => {
                  setHasFeedOptions(options)
                  setFormData({ ...formData, has_feed: options.find((e) => e.checked).value })
                }}
                type="radio"
              />

              {console.log(homepageOptions, ' homepageOptions')}

              <CheckboxRadio
                className="form-control"
                id="homepage"
                name="homepage"
                label="Homepage:"
                options={homepageOptions}
                handleOptions={(options) => {
                  setHomepageOptions(options)
                  setFormData({ ...formData, potential: options.find((e) => e.checked).name })
                }}
                type="radio"
              />
            </div>
          </>
        ) : null}
        <div className="companies-form--buttonsContainer">
          <button type="submit" className="btn btn-primary" disabled={checkUnsavedChanges()} id="company-submit-btn">
            {t('Guardar')}
          </button>
          <button
            type="button"
            className="btn btn-outline-primary"
            onClick={() => {
              if (checkUnsavedChanges()) {
                history.push('/companies')
              } else {
                setShowModal(true)
              }
            }}
          >
            {t('Cancelar')}
          </button>
        </div>
      </form>
    </div>
  )
}
